import type { Dispatch, SetStateAction } from 'react';
import type { UIElementProps } from '@adyen/adyen-web/dist/types/components/types';
import type { PlaceOrderMutationFn } from '../../../types';
import { PaymentResultCode } from '../../../types';
import { newRelicAvailabilityChecker } from '../../../utils/newrelic';
import { setItem } from '../../../utils/storage';

// Adyen docs - web components - multibanco
// https://docs.adyen.com/payment-methods/multibanco/web-component/?flow=Sessions+flow&integration=Component&version=5.65.0

export interface CreateMultibancoConfigProps {
  setIsPaymentBtnDisabled: Dispatch<SetStateAction<boolean>>;
  setPaymentInProgress: Dispatch<SetStateAction<boolean>>;
  setPaymentError: Dispatch<SetStateAction<boolean>>;
  setIsDialogOpen: Dispatch<SetStateAction<boolean>>;
  placeOrderMutation: PlaceOrderMutationFn;
  onBeforeSubmit: (data: unknown, actions: unknown) => Promise<void>;
}

export const createMultibancoConfig = ({
  setIsPaymentBtnDisabled,
  setPaymentInProgress,
  setIsDialogOpen,
  setPaymentError,
  placeOrderMutation,
  onBeforeSubmit,
}: CreateMultibancoConfigProps): Partial<UIElementProps> => ({
  showPayButton: false,
  beforeSubmit: async (data: any, _: any, actions: any) => {
    try {
      setIsPaymentBtnDisabled(true);
      setPaymentInProgress(true);

      const result = await placeOrderMutation();

      if (result?.data?.placeOrder.accepted) {
        setItem('PAYMENT_RESULT_CODE', PaymentResultCode.RECEIVED, true, 'sessionStorage');

        await onBeforeSubmit(data, actions);

        setIsDialogOpen(true);
      } else {
        actions.reject();

        setPaymentError(true);
        setIsPaymentBtnDisabled(false);
        setPaymentInProgress(false);
      }
    } catch (error) {
      actions.reject();

      setPaymentError(true);
      setIsPaymentBtnDisabled(false);
      setPaymentInProgress(false);

      console.error('Error during Multibanco payment processing:', error);
      newRelicAvailabilityChecker(() => {
        window.newrelic.noticeError(new Error(`Error during Multibanco payment processing: ${error}`));
      });
    }
  },
});
